import React from "react";
import StageBookViewer from "../components/StageBookViewer";
import { META, CHAPTERS } from "../data/ks1_book";

export default function Ks1BookViewer() {
  return (
    <StageBookViewer
      meta={META}
      chapters={CHAPTERS}
      accent="#CFA052"
      testIdPrefix="ks1"
      comingSoonNote="9 further chapters are in development for Key Stage 1."
    />
  );
}
